/* eslint-disable react/require-default-props */
function Twitter({
  width = '24',
  height = '22',
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6115 22L10.0621 14.0901L3.11488 22H0.175781L8.7581 12.2311L0.175781 0H7.72173L12.952 7.45502L19.5053 0H22.4444L14.2603 9.31648L23.1574 22H15.6115ZM18.8845 19.77H16.9058L4.38413 2.23H6.36312L11.3781 9.25316L12.2454 10.4719L18.8845 19.77Z"
        fill="#242E36"
      />
    </svg>
  );
}

export default Twitter;
